import { HTTP, HTTP_APP } from '@/shared/http';

import sortParticipants from '@/shared/sortParticipants';
import Vue from 'vue';

function sortComments(comments) {
  comments.sort((x, y) => {
    var xcreated = new Date(x.created_at);
    var ycreated = new Date(y.created_at);
    return ycreated - xcreated;
  });
  return comments;
}

export default {
  state: {
    tasks: [
      {
        id: 1,
        title:
          'Help clean up (17:00 - 18:00) aber sehr sehr lang .. aber sehr sehr lang ..aber sehr sehr lang ..',
        owner: null,
        due: '2022-04-23T18:25:43.511Z',
        description:
          'This is a long task description. This is a long task description. This is a long task description.  This is a long task description.  This is a long task description.  This is a long task description.  This is a long task description. ',
        comment: 'I will pick up the kiids at 11:00 from Oktoberfest',
        user: {
          name: 'Peter',
        },
      },
      {
        id: 2,
        title: 'Help clean up (17:00 - 18:00)',
        owner: null,
        due: '2022-05-23T18:25:43.511Z',
        description: 'This is a task description',
        comment: 'This is  a comment',
        user: null,
      },
    ],

    poll: null,
    defaultDuration: 60,
    currentParticipantName: null,
    images: [
      { id: 1, mode: 'light', url: '/images/white.jpg' },
      { id: 2, mode: 'light', url: '/images/grey.jpg' },
      { id: 3, mode: 'light', url: '/images/Orange by luke-chesser.jpg' },
      { id: 4, mode: 'light', url: '/images/Brown by thomas-lefebvre.jpg' },
      { id: 5, mode: 'light', url: '/images/red by james-lee.jpg' },
      { id: 6, mode: 'light', url: '/images/Blue by sincerely-media.jpg' },
      { id: 7, mode: 'light', url: '/images/Green by sincerely-media.jpg' },
      { id: 8, mode: 'light', url: '/images/Pink by sincerely-media.jpg' },
      { id: 9, mode: 'light', url: '/images/Colourful by gradienta.jpg' },
      {
        id: 10,
        mode: 'light',
        url: '/images/Colour Wall Art by alexander-schimmeck.jpg',
      },
      { id: 11, mode: 'light', url: '/images/Universe by jeremy-thomas.jpg' },
      { id: 12, mode: 'light', url: '/images/Triangles by ash-edmonds.jpg' },
      { id: 13, mode: 'light', url: '/images/Painting by andrian-valeanu.jpg' },
      { id: 14, mode: 'light', url: '/images/New Years by elisha-terada.jpg' },
      { id: 15, mode: 'light', url: '/images/Celebration by jason-leung.jpg' },
      {
        id: 16,
        mode: 'light',
        url: '/images/Abstract Painting by richard-horvath.jpg',
      },
      {
        id: 17,
        mode: 'light',
        url: '/images/Abstract Wall Art by john-schaidler.jpg',
      },
      { id: 18, mode: 'light', url: '/images/Forest by kunal-shinde.jpg' },
      { id: 19, mode: 'light', url: '/images/Rice Terrace by omer-rana.jpg' },
      { id: 20, mode: 'light', url: '/images/Beach by frank-mckenna.jpg' },
      { id: 21, mode: 'light', url: '/images/Baking by taylor-grote.jpg' },
      { id: 22, mode: 'light', url: '/images/Ballett by nihal-demirci.jpg' },
      { id: 23, mode: 'light', url: '/images/Ballons by content-pixie.jpg' },
      { id: 24, mode: 'light', url: '/images/Bar by steve-allison.jpg' },
      { id: 25, mode: 'light', url: '/images/Baseball by wendy-scofield.jpg' },
      { id: 26, mode: 'light', url: '/images/Billards by sigmund.jpg' },
      { id: 27, mode: 'light', url: '/images/Birthday by lidya-nada-MD.jpg' },
      {
        id: 28,
        mode: 'light',
        url: '/images/Computer Games by sean-stone.jpg',
      },
      {
        id: 29,
        mode: 'light',
        url: '/images/Board Games by karthik-balakrishnan.jpg',
      },
      { id: 30, mode: 'light', url: '/images/Casino by adrian-trinkaus.jpg' },
      { id: 31, mode: 'light', url: '/images/pexels-javon-swaby-3279685.jpg' },
      { id: 32, mode: 'light', url: '/images/Camping by kevin-schmid.jpg' },
      { id: 33, mode: 'light', url: '/images/Cats by the-lucky-neko.jpg' },
      {
        id: 34,
        mode: 'light',
        url: '/images/Chess by d-a-v-i-d-s-o-n-l-u-n-a.jpg',
      },
      { id: 35, mode: 'light', url: '/images/Christmas by eugenivy_now.jpg' },
      {
        id: 36,
        mode: 'light',
        url: '/images/Classic Concert by diogo-nunes.jpg',
      },
      { id: 37, mode: 'light', url: '/images/Cocktails by kobby-mendez.jpg' },
      {
        id: 38,
        mode: 'light',
        url: '/images/Concert by karsten-winegeart.jpg',
      },
      { id: 39, mode: 'light', url: '/images/Cooking by jorge-zapata.jpg' },
      { id: 40, mode: 'light', url: '/images/Darts by anastase-maragos.jpg' },
      { id: 41, mode: 'light', url: '/images/Disco by matthew-lejune.jpg' },
      { id: 42, mode: 'light', url: '/images/Dog by patrick-kool.jpg' },
      {
        id: 43,
        mode: 'light',
        url: '/images/Easter by melissa-walker-horn.jpg',
      },
      { id: 44, mode: 'light', url: '/images/Film by jeremy-yap.jpg' },
      { id: 45, mode: 'light', url: '/images/Fitness by chase-kinney.jpg' },
      { id: 46, mode: 'light', url: '/images/Gaming by heather-gill.jpg' },
      { id: 47, mode: 'light', url: '/images/Gardening by annie-spratt.jpg' },
      {
        id: 48,
        mode: 'light',
        url: '/images/Girls Night by helena-yankovska.jpg',
      },
      { id: 49, mode: 'light', url: '/images/Hiking by toomas-tartes.jpg' },
      {
        id: 50,
        mode: 'light',
        url: '/images/Hills summer by garrett-parker.jpg',
      },
      {
        id: 51,
        mode: 'light',
        url: '/images/Jam Session by john-matychuk.jpg',
      },
      { id: 52, mode: 'light', url: '/images/Lake by luca-bravo.jpg' },
      {
        id: 53,
        mode: 'light',
        url: '/images/Maledives by ishan-seefromthesky.jpg',
      },
      { id: 54, mode: 'light', url: '/images/Mens night out by kats-weil.jpg' },
      { id: 55, mode: 'light', url: '/images/Photography by char-beck.jpg' },
      { id: 56, mode: 'light', url: '/images/Records by wan-san-yip.jpg' },
      {
        id: 57,
        mode: 'light',
        url: '/images/Sewing by susan-holt-simpson.jpg',
      },
      { id: 58, mode: 'light', url: '/images/Surfing by nico-bhlr.jpg' },
      { id: 59, mode: 'light', url: '/images/Swimming by markus-spiske.jpg' },
      { id: 60, mode: 'light', url: '/images/Theatre by denise-jans.jpg' },
      { id: 61, mode: 'light', url: '/images/Wedding 2 by guanfranco-g.jpg' },
      {
        id: 62,
        mode: 'light',
        url: '/images/Winter Sports by pietro-de-grandi.jpg',
      },
      {
        id: 63,
        mode: 'light',
        url: '/images/pexels-andrea-piacquadio-863977.jpg',
      },
      {
        id: 64,
        mode: 'light',
        url: '/images/pexels-gonzalo-facello-1432039.jpg',
      },
      {
        id: 65,
        mode: 'light',
        url: '/images/pexels-jeandaniel-francoeur-4700762.jpg',
      },
      { id: 66, mode: 'light', url: '/images/pexels-jopwell-1325681.jpg' },
      { id: 67, mode: 'light', url: '/images/pexels-oleg-magni-1427741.jpg' },
      { id: 68, mode: 'light', url: '/images/pexels-picjumbocom-196652.jpg' },
      { id: 69, mode: 'light', url: '/images/pexels-pixabay-262524.jpg' },
    ],

    bgImage: { id: 3, url: '/images/white.jpg' },
    bgDefaultImage: { id: 3, url: '/images/white.jpg' },
    // bgDefaultImage: { id: 3, url: '/images/background_default_thumnail.jpg' },
    logoImage: { id: 1, url: '' },
    bgDeleteDefaultImage: { id: 2, mode: 'light', url: '/images/grey.jpg' },

    design: {
      align: 'left',
    },
    adminBackUpPreferenceList: null,
    adminUserName: null,
    participantBackup: null,
  },
  mutations: {
    log(msg) {
      console.log('commit mgs -', msg);
    },

    toggleDesignAlignment(state) {
      if (state.design.align == 'center') {
        state.design.align = 'left';
      } else {
        state.design.align = 'center';
      }
      console.log('new design config is:', state.design.align);
    },

    setParticipantBackup(state, participant) {
      state.participantBackup = participant;
    },

    setPoll(state, poll) {
      const defaults = {
        darkMode: false,
        mayBeAnswers: true,
        limitedVotesPerChoice: false,
        limitedVotesPerChoiceSpecific: false,
        limitedVotesPerEvent: true,
        votesLimit: 2,
        guestsLimit: 4,
        oneChoicePerParticipant: false,
        showStatisticToParticipants: false,
        allowComments: true,
        allowTasks: false,
        hiddenPoll: false,
        bookingModePoll: false,
        closedPoll: false,
        showCounts: false,
        notifyOnNewAnswer: true,
        notifyOnNewUser: true,
        mandatoryEmail: true,
        initialised: false,
        setDefaultAsNoForNotAnswered: false,
        allowDoNotKnowAnswer: true,
      };

      let options = poll.options;
      delete options.hideCounts;
      if (options.hiddenPoll && !options.showCounts) {
        defaults.showCounts = true;
      }

      options = Object.assign(defaults, options);
      poll.options = options;
      state.poll = poll;
      if (options.darkMode) {
        document.body.classList.remove('light-mode');
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
        document.body.classList.add('light-mode');
      }
    },

    setBgImageByUrl(state, url) {
      if (state.images && url) {
        const selectedImage = state.images.find((img) => img.url === url);
        if (selectedImage) {
          state.bgImage = selectedImage;
        } else {
          // if not found from the images list, then check from the user images
          let findInUser = state.poll.user.images.find(
            (img) => img.url === url
          );
          if (findInUser) {
            state.bgImage = findInUser;
          }
        }
      }
    },

    setBgImage(state, image) {
      state.bgImage = image;
      state.poll.bg_image_path = image.url;
      console.log('Update background image:', image);
      HTTP.post(
        `${process.env.VUE_APP_API_URI_SEGMENT}/poll/image/${state.poll.id}`,
        {
          image: { url: image.url },
        }
      )
        .then((response) => {
          console.log('response:%o' + response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    setBgImageOnlyForDisplay(state, image) {
      // This is used when you are creating a clone and you have to display the selected image of old poll
      // but you don't have to save until user save
      state.bgImage = image;
      state.poll.bg_image_path = image.url;
    },

    updateDuration(state, duration) {
      state.defaultDuration = duration;
    },

    // setOptions(state, options) {
    //   const defaults = {
    //     darkMode: false,
    //     mayBeAnswers: false,
    //     limitedVotesPerChoice: false,
    //     votesLimit: 2,
    //     oneChoicePerParticipant: false,
    //     showStatisticToParticipants: false,
    //     allowComments: true,
    //     hiddenPoll: false,
    //     showCounts: false,
    //     initialised: false,
    //   };
    //   options = Object.assign(defaults, options);
    //   state.poll.options = options;
    // },

    updateMayBeAnswers(state, value) {
      state.poll.options.mayBeAnswers = value;
    },

    updateLimitedVotesPerChoice(state, value) {
      state.poll.options.limitedVotesPerChoice = value;
    },

    updateLimitedVotesPerChoiceSpecific(state, value) {
      state.poll.options.limitedVotesPerChoiceSpecific = value;
    },

    updateLimitedVotesPerEvent(state, value) {
      state.poll.options.limitedVotesPerEvent = value;
    },

    updateVotesLimit(state, value) {
      state.poll.options.votesLimit = value;
    },

    updateGuestsLimit(state, value) {
      state.poll.options.guestsLimit = value;
    },

    updateOneChoicePerParticipant(state, value) {
      state.poll.options.oneChoicePerParticipant = value;
    },
    updateDarkMode(state, value) {
      state.poll.options.darkMode = value;
    },

    updateMandatoryEmail(state, value) {
      state.poll.options.mandatoryEmail = value;
    },

    updateShowStatisticToParticipants(state, value) {
      console.info('updateShowStatisticToParticipants', value);
      state.poll.options.showStatisticToParticipants = value;
    },

    updateAllowComments(state, value) {
      state.poll.options.allowComments = value;
    },

    updateAllowTasks(state, value) {
      state.poll.options.allowTasks = value;
    },

    updateHiddenPoll(state, value) {
      state.poll.options.hiddenPoll = value;
    },

    updateBookingModePoll(state, value) {
      state.poll.options.bookingModePoll= value;
    },

    updateClosedPoll(state, value) {
      state.poll.closed = value;
    },

    updateNotifyOnNewAnswer(state, value) {
      state.poll.options.notifyOnNewAnswer = value;
    },
    updateNotifyOnNewUser(state, value) {
      state.poll.options.notifyOnNewUser = value;
    },

    updateShowCounts(state, value) {
      state.poll.options.showCounts = value;
    },

    updateDelayInterval(state, value) {
      state.poll.delay_interval = value;
    },

    updateDelayType(state, value) {
      state.poll.delay_type = value;
    },

    // updateHidenCounts(state, value) {
    //   state.poll.options.hideCounts = value;
    // },

    updateTitle(state, value) {
      state.poll.title = value;
    },

    updateDeadline(state, value) {
      state.poll.deadline = value;
      if (value == null) {
        state.poll.delay_type = null;
        state.poll.delay_interval = null;
      }
    },

    updateType(state, value) {
      state.poll.type = value;
    },

    updateDescription(state, value) {
      state.poll.description = value;
    },

    updateName(state, value) {
      console.log('updateName:', value);
      state.poll.user.name = value;
      state.poll.user_name = value;
      state.currentParticipantName = value;
      state.poll.participants[0].name = value;
    },

    updateEmail(state, value) {
      state.poll.user.email = value;
      let user = state.poll.participants[0].user;
      user.email = value;
      state.poll.participants[0].user = user;
    },

    toggleFinalChoice(state, choice) {
      var pos = state.poll.choices.findIndex((obj) => obj.id == choice.id);
      choice.final = !choice.final;
      state.poll.choices[pos] = choice;
    },

    updateChoices(state, choices) {
      console.log('Store updateChoices');

      state.poll.choices = choices.sort(
        (a, b) => new Date(a.start) - new Date(b.start)
      );
    },

    updateChoicesNoSort(state, choices) {
      console.log('Store updateChoicesNoSort');
      state.poll.choices = choices;
    },

    cleanAndSortChoices(state, choices) {
      console.log('Store cleanAndSortChoices');
      // AG: remove unencoded choiceIds (-1, -2, ...)
      state.poll.choices = choices
        .map((choice) => {
          if (isNaN(choice.id)) {
            return choice;
          } else {
            delete choice.id;
            return choice;
          }
        })
        .sort((a, b) => {
          // do not chnage the order of suvey choices
          if (a.start == null || b.start == null) return -1;
          return new Date(a.start) - new Date(b.start);
        });
      console.log('sorted choices:', state.poll.choices);
    },

    cleanChoices(state, choices) {
      console.log('Store cleanChoices');
      // AG: remove unencoded choiceIds (-1, -2, ...)
      state.poll.choices = choices.map((choice) => {
        if (isNaN(choice.id)) {
          return choice;
        } else {
          delete choice.id;
          return choice;
        }
      });
      console.log('clean choices:', state.poll.choices);
    },

    removeChoice(state, id) {
      console.log('store - remove choice:', id);
      let choices = state.poll.choices.filter((item) => item.id != id);
      console.log('store - choice:', choices);
      state.poll.choices = choices;
    },

    removeParticipant(state, participant) {
      console.log('store - remove participant:', participant);

      let participants = state.poll.participants.filter(
        (item) => item.id != participant.id
      );
      state.poll.participants = participants;
    },

    removeInvitation(state, invitation) {
      console.log('store - remove invitation:', invitation);

      let invitations = state.poll.invitations.filter(
        (item) => item.id != invitation.id
      );
      state.poll.invitations = invitations;
    },

    updateInvitations(state, invitations) {
      console.log('Update invitations:', invitations);
      state.poll.invitations = invitations;
    },

    updateParticipants(state, participants) {
      console.info('Update participants:', participants.lemgth, participants);
      state.poll.participants = participants;

      let result = null;
      let foundParticipants = state.poll.participants.filter(
        (item) => item.isCurrentUser
      );
      console.log(
        'updateParticipants - current participants:',
        foundParticipants
      );
      if (foundParticipants.length > 0) {
        result = foundParticipants[0].name;
      }

      state.currentParticipantName = result;
    },

    updateParticipantAttributes(state, attributes) {
      state.poll.participant_attributes = attributes;
    },

    // Task mutation

    updateTaskCount(state, count) {
      state.poll.taskCount = count;
    },

    updateTask(state, task) {
      var pos = state.poll.tasks.findIndex((obj) => obj.id == task.id);
      Vue.set(state.poll.tasks, pos, task);
    },

    updateTasks(state, tasks) {
      state.poll.tasks = tasks;
    },

    updateComments(state, comments) {
      state.poll.comments = comments;
    },

    updateInvitation(state, invitation) {
      var pos = state.poll.invitations.findIndex(
        (obj) => obj.id == invitation.id
      );
      state.poll.invitations[pos] = invitation;
    },
    updateParticipant(state, participant) {
      var pos = state.poll.participants.findIndex(
        (obj) => obj.id == participant.id
      );

      state.poll.participants[pos] = participant;

      Vue.set(state.poll.participants, pos, participant);

      if (state.poll.tasks) {
        const tasks = state.poll.tasks;

        tasks.forEach((task) => {
          if (task.resources) {
            task.resources.forEach((r) => {
              if (r.participant.id == participant.id) {
                r.participant.name = participant.name;
              }
            });
          }
        });
      }
    },

    updateParticipantChoice(state, data) {
      // data { participant, choice_id, value }
      const participant = state.poll.participants.find(
        (p) => p.id === data.participant.id
      );
      if (participant) {
        if (data.oneChoicePerParticipant && data.value > 0) {
          console.error('Reset participant choice');
          participant.preference_list.forEach((element) => (element.value = 0));
        }
        const choice = participant.preference_list.find((c) => {
          if (c.choice_id === data.choice_id) {
            c.updated = true;
            return c;
          }
        });
        if (choice) {
          choice.value = data.value;
        } else {
          console.log('Choice not found:', data.choice_id, participant);
        }
      }
    },
    updateParticipantAllChoices(state, data) {
      // data { participant, choice_id, value }
      const participant = state.poll.participants.find(
        (p) => p.id === data.participantId
      );
      if (participant) {
        if (data.oneChoicePerParticipant && data.value > 0) {
          console.error('Reset participant choice');
          participant.preference_list.forEach((element) => (element.value = 0));
        }

        for (let j = 0; j < data.choices.length; j++) {
          for (let i = 0; i < participant.preference_list.length; i++) {
            if (
              participant.preference_list[i].choice_id ==
              data.choices[j].choiceId
            ) {
              participant.preference_list[i].value = data.choices[j].value;
              break;
            }
          }
        }
        // const choice = participant.preference_list.find(
        //   (c) => c.choice_id === data.choice_id
        // );
        // if (choice) {
        //   choice.value = data.value;
        // } else {
        //   console.log('Choice not found:', data.choice_id, participant);
        // }
      }
    },
    setLogo(state, image) {
      state.logoImage = image;
      // state.poll.logo_image_path = image.url;
      console.log('Update logo image:', image);
      // HTTP.post(
      //   `${process.env.VUE_APP_API_URI_SEGMENT}/poll/logo/${state.poll.id}`,
      //   {
      //     image: { url: image.url },
      //   }
      // )
      //   .then((response) => {
      //     console.log('response:%o' + response.data);
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   });
    },
    setLogoByUrl(state, url) {
      state.logoImage = { id: 1, url: url };
    },
    setDesignId(state, value) {
      state.poll.design_id = value;
    },
    setDefaultAsNoForNotAnswered(state, value) {
      state.poll.options.setDefaultAsNoForNotAnswered = value;
    },
    updateAllowDoNotKnowAnswer(state, value) {
      state.poll.options.allowDoNotKnowAnswer = value;
    },
    updateAdminBackUpPreferenceList(state, adminPreferenceValue) {
      state.adminBackUpPreferenceList = adminPreferenceValue;
    },
    updateAdminUserNameWhenCreateNewPoll(state, adminUserName) {
      state.adminUserName = adminUserName;
    },
  },
  getters: {
    // the current participant name is updated by updateParticipants

    // currentParticipantName(state) {

    //   let result = null;
    //   let foundParticipants = state.poll.participants.filter(
    //     (item) => item.isCurrentUser
    //   );
    //   console.error(
    //     'currentParticipantName, foundParticipants:',
    //     foundParticipants
    //   );
    //   if (foundParticipants.length > 0) {
    //     result = foundParticipants[0].name;
    //   }
    //   return result;
    // },

    isDeadlinePassed(state) {
      if (!state.poll.deadline) return false;

      const today = new Date();
      let deadline = new Date(state.poll.deadline);
      deadline.setDate(deadline.getDate());
      //console.log('isDweadlinePassed:', today, deadline);
      return today > deadline;
    },

    getOwnerParticipantName(state) {
      if (state.poll.user == null) {
        console.log('poll without participant:', state.poll);
        return null;
      }
      const ownerId = state.poll.user.id;
      for (var participant of state.poll.participants) {
        if (participant.user_id == ownerId) {
          return participant.name;
        }
      }
      return state.poll.user.name;
    },

    isPollEditable(state, getters, rootState, rootGetters) {
      if (state.poll.closed) return false;
      if (rootGetters.isOwner) return true;
      if (getters.isDeadlinePassed) return false;
      return true;
    },

    bgImage(state) {
      return state.bgImage;
    },

    logoImage(state) {
      return state.logoImage;
    },

    bgDefaultImage(state) {
      return state.bgDefaultImage;
    },

    bgDeleteDefaultImage(state) {
      return state.bgDeleteDefaultImage;
    },

    currentParticipantName(state) {
      return state.currentParticipantName;
    },
    pollId(state) {
      return state.poll.id;
    },
    images(state) {
      return state.images;
    },
    adminKey(state) {
      let ownerId = state.poll.user.id;

      let adminKey = ownerId.substring(ownerId.length - 4) + ownerId;
      console.log('Getters getAdminKey:', adminKey);
      return adminKey;
    },
    publicKey(state) {
      let ownerId = state.poll.user.id;

      let publicKey = ownerId.substring(0, 4) + ownerId;
      console.log('Getters publicKey:', publicKey);
      return publicKey;
    },

    pollComments(state, getters, rootState, rootGetters) {
      if (!rootGetters.isOwner && state.poll.options.hiddenPoll) {
        // state.poll.participants
        let userId = rootGetters.userId;
        // console.log('pollComments --> inside if');
        // filter comment on participant Id when it is hidden poll.
        // anonymous user can not see any comment
        return state.poll.comments.filter((comment) => {
          if (rootGetters.isOwner) return true;
          if (comment.user_id === null) {
            return false;
          }
          return comment.user_id == userId;
        });
      }
      // console.log('pollComments --> outside if');
      return state.poll.comments;
    },

    pollTasks(state) {
      if (state.poll.tasks == null) {
        console.log('pollTasks was null');
        state.poll.tasks = [];
      }
      return state.poll.tasks;
    },

    pollParticipants(state) {
      if (state.poll && state.poll.participants) {
        return state.poll.participants;
      } else {
        return [];
      }
    },

    getPollOptionValue: (state) => (option) => {
      console.log('getPollOptionValue for ', option);
      if (
        state.poll.options &&
        Object.prototype.hasOwnProperty.call(state.poll.options, option)
      ) {
        console.log('getPollOptionValue in if ', state.poll.options[option]);
        return state.poll.options[option];
      } else {
        console.log('getPollOptionValue in else ', option);
        return false;
      }
    },
    getPollDesignId(state) {
      return state.poll.design_id;
    },
    getAdminBackUpPreferenceList(state) {
      return state.adminBackUpPreferenceList;
    },
    getAdminUserName(state) {
      return state.adminUserName;
    },
  },
  actions: {
    loadPoll({ commit }, poll) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = poll.key
        ? apiUrl + '/poll/' + poll.pollId + '/' + poll.key
        : apiUrl + '/poll/' + poll.pollId;
      console.log('load poll by using the following url:', url);
      return HTTP.get(url)
        .then((response) => {
          let poll = response.data;

          let comments = poll.comments;
          poll.comments = sortComments(comments);
          //console.error('AdminKey:', poll.adminKey);
          commit('setPoll', poll);
          commit('setBgImageByUrl', poll.bg_image_path);
          console.log('logo path ==> ', poll.logo_image_path);
          commit('setLogoByUrl', poll.logo_image_path);
          return response;
        })
        .catch((error) => console.log(error));
    },

    updateChoices({ commit, state, rootState }, choices) {
      console.info('updateChoices - choices:', state.poll.participants);
      let pollId = state.poll.id;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/poll/choices/' + pollId;
      console.info('Store - Update choices for:', pollId, choices);
      commit('cleanAndSortChoices', choices);
      console.info('Update backend with new choices:', choices);
      // const currentParticipant = state.poll.participants.find(
      //   (participant) => participant.isCurrentUser
      // );
      return HTTP.post(url, {
        choices: choices,
      })
        .then((response) => {
          //console.log('updateChoices response:', response);
          let choices = response.data.choices;
          commit('updateChoices', choices);

          let participants = response.data.participants;

          // keep the current user

          for (let i = 0; i < state.poll.participants.length; i++) {
            const p = state.poll.participants[i];
            //console.log('(updateChoices) - Check for participant:', p);
            if (!p.isCurrentUser && !p.isCurrentUserParticipant) continue;
            let participant = participants.find((item) => item.id == p.id);
            participant.isCurrentUser = p.isCurrentUser;
            participant.isCurrentUserParticipant = p.isCurrentUserParticipant;
          }
          sortParticipants(participants, rootState.Login.userId);
          console.log(
            'updateChoices - update sorted participants:',
            participants
          );
          commit('updateParticipants', participants);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    updateChoicesNoSort({ commit, state }, choices) {
      let pollId = state.poll.id;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/poll/choices/' + pollId;
      commit('cleanChoices', choices);
      console.log('Store - Update choices (no sort) for:', pollId, choices);
      const currentParticipant = state.poll.participants.find(
        (participant) => participant.isCurrentUser
      );
      return HTTP.post(url, {
        choices: choices,
      })
        .then((response) => {
          let choices = response.data.choices;
          commit('updateChoicesNoSort', choices);

          let participants = response.data.participants;

          let participant = participants.find(
            (p) => p.id == currentParticipant.id
          );
          participant.isCurrentUser = true;
          commit('updateParticipants', participants);
          commit('updateParticipant', participant);
          console.log('Participants after updateChoicesNoSort:', participants);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    updateChoice({ commit }, data) {
      // data { participant, choice_id, value }

      console.log('Action - update choice:', data);
      let participant = data.participant;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/participant/' + participant.id;

      return HTTP_APP.post(url, data)
        .then((response) => {
          commit('updateParticipantChoice', data);
          console.log(
            'Processing post participants return data',
            response.data
          );
          return response;
        })
        .catch((error) => console.log(error));
    },
    updateChoiceWithoutAPIRequest({ commit }, data) {
      commit('updateParticipantChoice', data);
    },
    updateChoicesV2({ commit }, data) {
      // data { participant, choice_id, value }

      console.log('Action - update all choices:', data);
      // let participant = data.participant;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/v2/participant/' + data.participantId;

      return HTTP_APP.post(url, data)
        .then((response) => {
          if (!response.data.error) {
            commit('updateParticipantAllChoices', data);
          }
          console.log(
            'Processing post participants return data',
            response.data
          );
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    removeParticipant({ commit }, participant) {
      return HTTP.delete('/api/participant/' + participant.id, {})
        .then((response) => {
          console.log('response:', response);
          commit('removeParticipant', participant);
          commit('updateInvitations', response.data.invitations);
          return HTTP.get('/api/task/' + participant.poll_id, {}).then(
            (response) => {
              commit('updateTasks', response.data);
            }
          );
        })
        .catch((e) => {
          console.log(e);
        });
    },

    sendInvitations({ commit }, invitations) {
      return HTTP.post('/api/invitation', invitations)
        .then((response) => {
          console.log('response:%o' + response.data);

          const poll = response.data;

          const invitations = poll.invitations;
          commit('updateInvitations', invitations);

          const participants = poll.participants;
          commit('updateParticipants', participants);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    removeInvitation({ commit }, invitation) {
      HTTP.delete('api/invitation/' + invitation.id, {})
        .then((response) => {
          console.log('response:', response);
          commit('removeInvitation', invitation);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    invitationVisit({ commit }, invitation) {
      HTTP.post('/api/invitation/visit/' + invitation.id, {})
        .then((response) => {
          console.log('response:', response);
          commit('updateInvitation', invitation);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    updateParticipantName({ commit }, participant) {
      HTTP.put('/api/participant/name/' + participant.id, {
        name: participant.name,
      })
        .then((response) => {
          console.log('response updateParticipantName:', response);
          commit('updateParticipant', participant);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    updateParticipant({ commit }, participant) {
      HTTP.put('/api/participant/' + participant.id, {
        participant: participant,
      })
        .then((response) => {
          console.log('response updateParticipant:', response);
          commit('updateParticipant', participant);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    addParticipant({ commit, state }, participant) {
      // remember the participant id to find out all participants belonging to this user
      participant.choice = -1;

      participant.preferences = state.poll.choices.map((choice) => {
        return {
          choice_id: choice.id,
          value: -1,
        };
      });

      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/poll/' + state.poll.id;

      return HTTP.post(url, participant)
        .then((response) => {
          let participant = response.data;
          console.log('Created participant:', participant);

          let participants = state.poll.participants;
          participants.push(participant);

          // sortParticipants(participants, currentUserId);
          commit('updateParticipants', participants);
          return participant;
        })
        .catch((error) => console.log(error));
    },

    updateParticipantAttributes({ commit, state }, attributes) {
      console.log('Action updateParticipantAttributes:', attributes);

      for (const attribute of attributes) {
        if (attribute.id < 0) attribute.id = ''; // to avoid  decoding of public ids
      }
      HTTP.put('/api/participantattributes', {
        poll_id: state.poll.id,
        pattributes: attributes,
      })
        .then((response) => {
          const attributes = response.data;
          console.log('updated participant attributes :', attributes);
          commit('updateParticipantAttributes', attributes);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // Task actions
    addTask({ commit, state }, task) {
      console.log('Action add task:', task);

      const newTask = {
        title: task.title,
        description: task.description,
        poll_id: task.poll_id,
        resource_count: task.resource_count,
        user_id: task.user_id,
      };
      HTTP.post('/api/task', {
        task: newTask,
      })
        .then((response) => {
          console.log('response update Task:', response.data);
          const updatedTask = response.data;
          const tasks = state.poll.tasks;
          tasks.push(updatedTask);
          commit('updateTasks', tasks);
          const count = state.poll.taskCount + 1;
          commit('updateTaskCount', count);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    updateTask({ commit }, task) {
      console.log('Action update task:', task);
      HTTP.put('/api/task/' + task.id, {
        task: task,
      })
        .then((response) => {
          console.log('response update Task:', response.data);
          const updatedTask = response.data;
          commit('updateTask', updatedTask);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    deleteTask({ commit, state }, task) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = `${apiUrl}/task/${task.id}`;
      HTTP.delete(url)
        .then((response) => {
          console.log('response deleteTask:', task.id, response);
          if (response.data === 'OK') {
            const tasks = state.poll.tasks;
            tasks.deleteObjectById(task.id);
            console.log('after deleteTask:', tasks);
            state.poll.tasks = tasks;
            const count = state.poll.taskCount - 1;
            commit('updateTaskCount', count);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    updateResource({ commit }, resource) {
      console.log('Action update task:', resource);
      HTTP.put('/api/resource/' + resource.id, {
        resource,
      })
        .then((response) => {
          console.log('response update resource:', response.data);
          const updatedTask = response.data;
          commit('updateTask', updatedTask);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    unassignResource({ commit }, resource) {
      console.log('Action unasign resource:', resource);
      HTTP.delete('/api/resource/' + resource.id, {
        resource,
      })
        .then((response) => {
          console.log('response assign resource:', response.data);
          const updatedTask = response.data;
          commit('updateTask', updatedTask);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    assignResource({ commit }, resource) {
      console.log('Action assign resource:', resource);
      HTTP.post('/api/resource', {
        resource,
      })
        .then((response) => {
          console.log('response update Task:', response.data);
          const updatedTask = response.data;
          commit('updateTask', updatedTask);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // comment support
    addComment({ commit, state, rootGetters }, comment) {
      let pollId = state.poll.id;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = `${apiUrl}/comment/${pollId}`;
      const userId = rootGetters.userId;
      console.log('action addComment - userId:', userId);
      comment.userId = userId;
      HTTP.post(url, {
        comment: comment,
      })
        .then(() => {
          // console.log('response addComment:', response.data);

          // const newComment = response.data;
          // if (response.data && response.data.id) {
          //   state.poll.comments.unshift(newComment);
          // }
          const url = `${apiUrl}/comments/${pollId}`;
          HTTP.get(url)
            .then((response) => {
              console.log('response addComment:', response.data);
              // const comments = response.data;
              commit('updateComments', response.data);
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    deleteComment({ state }, commentId) {
      // let pollId = state.poll.id;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = `${apiUrl}/comment/${commentId}`;
      HTTP.delete(url)
        .then((response) => {
          console.log('response deleteComment:', response);
          if (response.data === 'OK') {
            state.poll.comments.deleteObjectById(commentId);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    deactivateNotifications(participantId) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/participant/comments/deactivate/' + participantId;

      HTTP.put(url)
        .then((response) => {
          console.log('deactivate response ', response);
        })
        .catch((error) => console.log(error));
    },

    activateNotifications(participantId) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/participant/comments/activate/' + participantId;

      HTTP.put(url)
        .then((response) => {
          console.log('activate response ', response);
        })
        .catch((error) => console.log(error));
    },

    updateDesignIdInPoll({ commit }, value) {
      commit('setDesignId', value);
    },

    setDarkMode({ commit }, value) {
      commit('updateDarkMode', value);
    },
    updateAdminBackUpPreferenceList({ commit }, adminPreferenceValue) {
      commit('updateAdminBackUpPreferenceList', adminPreferenceValue);
    },
    updateAdminUserNameWhenCreateNewPoll({ commit }, adminUserName) {
      commit('updateAdminUserNameWhenCreateNewPoll', adminUserName);
    },
  },
};
